module.exports = __webpack_public_path__ + "6930bbdf198a99aa89cc6bb32f5787a4.svg";